import {z} from 'zod';

import {VehicleFinancingBalloonPaymentSchema, VehicleFinancingTermSchema} from '@dms/api/sales';

import {RateMatrixCellDataSchema} from './RateMatrixCellData';

export const RateMatrixValueSchema = z.object({
  availableTerms: z.array(VehicleFinancingTermSchema),
  cells: z.record(z.string(), RateMatrixCellDataSchema),
  availableBalloonBrackets: z.array(VehicleFinancingBalloonPaymentSchema),
  defaultBalloonPayment: VehicleFinancingBalloonPaymentSchema.nullable(),
});

export type RateMatrixValue = z.infer<typeof RateMatrixValueSchema>;
